/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import { initTracker } from 'documents-lib/js/tracking/tracker';
import * as PublicActivityApi from '../api/PublicActivityApi';

const viewPage = ({
  presentation,
  activityId,
  pageIndex
}) => PublicActivityApi.viewPage(presentation.id, presentation.accessId, activityId, pageIndex);

export default ((stateToPresentation, handlers) => store => {
  let activityId = null;
  return next => action => {
    switch (action.type) {
      case handlers.identify:
        {
          const {
            presentation
          } = stateToPresentation(store.getState());
          initTracker({
            isPublic: true
          });
          PublicActivityApi.createActivity(presentation.id, presentation.accessId, action.payload).then(activity => {
            activityId = activity.id || activity;
            viewPage({
              presentation,
              activityId,
              pageIndex: 0
            });
          });
          break;
        }

      case handlers.viewPage:
        {
          if (activityId === null) {
            break;
          }

          const {
            presentation
          } = stateToPresentation(store.getState());
          viewPage({
            presentation,
            activityId,
            pageIndex: action.payload
          });
          break;
        }

      case handlers.finish:
        {
          if (activityId === null) {
            break;
          }

          const {
            presentation
          } = stateToPresentation(store.getState());
          PublicActivityApi.finishActivity(presentation.id, presentation.accessId, activityId);
          break;
        }

      default:
        break;
    }

    return next(action);
  };
});